import { toBackendDateTime } from 'Util/formatters'
import { useCallback } from 'react'

export function useDateTimeChange<T>(setState: React.Dispatch<React.SetStateAction<T>>) {
  return useCallback(
    (value: Date | null, name: string) => {
      setState(prev => ({ ...prev, [name]: toBackendDateTime(value) }) as T)
    },
    [setState]
  )
}
